import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class TicketModalGroupRoundButtons extends Vue {

  @Prop({ required: true, type: [Array] })
  buttons: { key: string, translationKey: string, value: boolean }[]

  @Prop({ default: false, type: [Boolean, String, Number] })
  value: boolean | string | number;

  @Prop({ default: false, type: [Boolean] })
  disabled: boolean;

  get vModel(): boolean | string | number { return this.value; }
  set vModel(value: boolean | string | number) { this.$emit('input', value); }

  get coButtons(): { key: string, translationKey: string, value: boolean }[] {
    return this.buttons;
  }


  handleButtonClick(value: boolean) {
    this.$emit('input', value);
    this.$emit('onChange', value)
  }

  getActivedColor(value: boolean): boolean {
    return this.vModel === value;
  }
}

export default TicketModalGroupRoundButtons;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-group-round-buttons/index.ts